module.exports = __webpack_public_path__ + "static/highway-from-the-top-fdb471ba273f34f9ec02e0543f32d032.jpg";